import React from 'react';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import Style from './shape-link-flag.css';
import LinkImg from '../../../../img/canvas/link-flag.svg';
import connect from '@src/js/separate-logic/connect';
import ShapeLinkFlagModel from './shape-link-flag-model';
import ShapeLinkFlagPresenter from './shape-link-flag-presenter';

interface IShapeLinkFlagProps {
    // state
    show: boolean;
    modelStateCroping: boolean;

    // presenter function
    handleIconClick: (e) => void;
    handleDoubleClick: (e) => void;
    getCroping: () => boolean;

    // parent props
    style: any;

    setRef: (name: string, ref: any) => void;
}

export class ShapeLinkFlag extends React.Component<IShapeLinkFlagProps> {
    public static displayName = 'ShapeLinkFlag'; // 声明displayName，单元测试用于查找组件

    public static defaultProps = {
        setRef: () => {},
    };
    public render() {
        const { show, setRef, handleIconClick, handleDoubleClick } = this.props;
        if (this.isReturnNull()) return null;
        const style = {
            display: show ? 'block' : 'none',
            right: ptToCanvas(8),
            bottom: ptToCanvas(8),
            width: ptToCanvas(22),
            height: ptToCanvas(22),
            boxShadow: `0 ${ptToCanvas(2)}px ${ptToCanvas(4)}px 0 rgba(0, 0, 0, 0.24)`,
            border: `solid ${ptToCanvas(1)}px white`,
            ...this.props.style,
        };

        return (
            <div style={style} onClick={handleIconClick}  onDoubleClick={handleDoubleClick} className={Style['shape-link']}
                ref={ref => setRef('linkDom', ref)}>
                <img src={LinkImg} style={{
                    width: ptToCanvas(12),
                    height: ptToCanvas(12),
                    marginLeft: ptToCanvas(4),
                    marginTop: ptToCanvas(4),
                    cursor: 'pointer',
                }}/>
            </div>
        );
    }
    private isReturnNull = () => {
        const { show, getCroping, modelStateCroping } = this.props;
        // 如果presenter存在，用presenter的判断 否则用model的默认值判断
        if (!show) return true;
        if (getCroping?.()) return true;
        return modelStateCroping;
    };
}

export default connect(
    ShapeLinkFlagPresenter,
    ShapeLinkFlagModel,
    ShapeLinkFlag,
);
